import { Box, Typography } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import { Outlet } from "react-router-dom";
import { useAppTranslation } from "../hooks/useAppTranslation";

interface RequireCompanyProps {
  selectedCompany: string;
}

export default function RequireCompany({
  selectedCompany,
}: RequireCompanyProps) {
  const { t } = useAppTranslation("common");

  if (!selectedCompany) {
    return (
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 3,
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            maxWidth: 520,
          }}
        >
          {/* ICON */}
          <BusinessIcon
            sx={{
              fontSize: 72,
              color: "text.secondary",
              opacity: 0.35,
              mb: 3,
            }}
          />

          {/* TITLE */}
          <Typography
            variant="h4"
            fontWeight={600}
            sx={{ mb: 2 }}
          >
            {t("Wybierz firmę")}
          </Typography>

          {/* DESCRIPTION */}
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              lineHeight: 1.6,
              mb: 4,
            }}
          >
            {t("Aby kontynuować pracę, wybierz firmę z listy")}
            {t("w górnym pasku aplikacji.")}
          </Typography>
        </Box>
      </Box>
    );
  }

  return <Outlet />;
}
